import {
  ref,
  computed,
  nextTick,
  toValue,
  watch,
  onMounted,
  onBeforeUnmount,
} from 'vue';

/**
 * Pages that own a header of their own (the conversation list, for one) teleport
 * it into the global topbar instead of stacking a second h-14 band under it.
 * The topbar hides its route-derived title while that slot is occupied.
 */
export const TOPBAR_SLOT_ID = 'pz-topbar-left';

const occupants = ref(0);

export const isTopbarSlotOccupied = computed(() => occupants.value > 0);

/**
 * @param {import('vue').MaybeRefOrGetter<boolean>} isActive whether the page is
 * currently showing its header. A page that hides itself (the list panel in the
 * expanded layout) must release the slot so the topbar shows the route title again.
 */
export function useTopbarSlot(isActive = true) {
  let registered = false;
  let isMounted = false;

  const sync = () => {
    const active = Boolean(toValue(isActive));
    if (active === registered) return;
    registered = active;
    occupants.value += active ? 1 : -1;
  };

  // Deferred: flipping this during the mount patch would re-render the topbar
  // while the teleport is still being inserted into it.
  onMounted(() => {
    isMounted = true;
    nextTick(sync);
  });

  watch(
    () => Boolean(toValue(isActive)),
    () => {
      if (isMounted) nextTick(sync);
    }
  );

  onBeforeUnmount(() => {
    if (!registered) return;
    registered = false;
    occupants.value -= 1;
  });
}
